export enum  PhxInterceptPanelType {
    comingSoon = 1,
    error = 2
}
